/**
 * 用来在内存中保存一些数据的工具模块
 */
export default {
    user: {} //用来保存当前用户
}